import React from 'react'

import { NotFound } from '@factorialco/deprecated-design-system'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'

import Body from './Body'
import Provider from './Provider'
import './index.styles.css'
interface NotFoundProp {
  active: boolean
  title: string
  description: string
}

interface Props {
  isLoading?: boolean
  notFound?: NotFoundProp
}

interface Subcomponents {
  Header: typeof Header
  Body: typeof Body
  Footer: typeof Footer
}

type Component = React.FC<React.PropsWithChildren<Props>> & Subcomponents

/**
 * @deprecated use ResponsivePage
 */
const Page: Component = ({ isLoading = false, notFound, children }) => (
  <Provider isLoading={isLoading}>
    <div className={'Page_page'} data-scroll-container>
      <ErrorBoundary>
        {notFound && notFound.active ? (
          <NotFound title={notFound.title} description={notFound.description} />
        ) : (
          children
        )}
      </ErrorBoundary>
    </div>
  </Provider>
)

const Header = ({ children }: React.PropsWithChildren) => <>{children}</>

const Footer = ({ children }: React.PropsWithChildren) => <>{children}</>

Page.Header = Header
Page.Body = Body
Page.Footer = Footer

export default Page
